import Datatypes from "./views/Datatypes.vue";

const moduleRoutes = [
	{
		path: "/:domainId/datatypes",
		name: "Datatypes",
		component: Datatypes,
	},
];

export default moduleRoutes;
